/* eslint-disable react/no-array-index-key */

import React, { FC } from 'react';
import styles from './legislation_parts.module.scss';
import { MaterialIcon } from '../../../../components/material-icon/MaterialIcon';

type Props = {
  parts: Array<string>;
};

export const LegislationParts: FC<Props> = ({ parts }) => {
  return (
    <div className={styles.container}>
      {parts.map((item, index) => {
        const element = (
          <span
            dangerouslySetInnerHTML={{
              __html: item,
            }}
            key={index} // eslint-disable-line react/no-array-index-key
          />
        );

        if (index === 0) {
          return element;
        }
        return (
          <span key={index}>
            <MaterialIcon name="keyboard_arrow_right" className={styles.icon} />
            {element}
          </span>
        );
      })}
    </div>
  );
};
